
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from 'src/app/security/security.service';
import { MessageService } from 'src/app/common/services/message';
import { UserService } from 'src/app/pages/user/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PermissionService } from '../../service/permission.service';
import { PasswordUpdateComponent } from 'src/app/pages/user/password-update/password-update.component';

@Component({
  selector: 'app-frame-layout',
  templateUrl: './app-frame-layout.component.html',
  styleUrls: ['./app-frame-layout.component.scss']
})
export class AppFrameLayoutComponent implements OnInit {
  isCollapsed = false;
  nickName = 'Guest';
  photoUrl = '';
  menus: any[] = [];
  tabs: any[] = [];
  selectedIndex = 0;
  activeMenuId =  '';
  constructor(private sanitizer: DomSanitizer, private securityService: SecurityService,private permissionService: PermissionService,private modalService: NzModalService, private router: Router, private message: MessageService, private userService: UserService) {
  }
  ngOnInit() {
    this.nickName = this.securityService.user.nick_name;
    this.photoUrl = this.securityService.user.avatar_url;
    this.loadActiveMenuFromStorage();
  }
  ngOnDestroy() {
    // 移除事件监听器
    window.removeEventListener('storage', this.onStorageChange.bind(this));
  }
  // 处理storage变化事件
  onStorageChange(event: StorageEvent) {
    console.log('storage event:', event);
    if (event.key === 'menu' && event.newValue) {
      try {
        const menuObj = JSON.parse(event.newValue);
        this.activeMenuId = menuObj.id;
        console.log('activeMenuId updated from storage:', this.activeMenuId);
      } catch (e) {
        console.error('Failed to parse menu from storage:', e);
      }
    }
  }
  loadActiveMenuFromStorage() {
    const menuObj = localStorage.getItem('menu');
    if (menuObj) {
      try {
        const menu = JSON.parse(menuObj);
        this.activeMenuId = menu.id;
        console.log('this.activeMenuId', this.activeMenuId);
      } catch (e) {
        console.error('Failed to parse menu from storage:', e);
      }
    }
  }
  ngAfterViewInit() {

    this.userService.getUserPermissions().subscribe((res: any) => {
      if (res.Success) {
        // 使用方式
        const rawData = res.Data; // 原始扁平数据
        rawData.push({id:'61cfbb53-7c1c-4ae9-8e88-35513fe4be89',name:'驾驶舱统计数据',href:'/trace/statistic',open:true})
        this.menus = this.buildMenuTree(rawData); // 根节点的ParentID为null
        console.log(this.menus);
        var menu = rawData.find((s: any) => s.open);
        if (menu) {
          this.onMenuClick(menu);
        }
        const permissionKeys = res.Data.map((item: any) => item.id);
        this.permissionService.setPermissions(permissionKeys);
      }
    });
    //const userId = this.securityService.user.id;
    //this.loadUserPermissions(this.securityService.user.id);
  }
  // private loadUserPermissions(userId: string) {
  //   this.userService.getPermissions(userId).subscribe((s: any) => {
  //     if (s.Success && s.Data) {
  //       const permissionKeys = s.Data.map((item: any) => item.id);
  //       debugger;
  //       this.permissionService.setPermissions(permissionKeys);
  //     }
  //   });
  // }
  // 递归构建树形结构
  buildMenuTree(items: any[], parentId: any = null): any[] {
    // 筛选出当前父节点的子项
    const children = items.filter(item => item.parent_id === parentId)
      // 为每个子项递归查找它们的子项
      .map(item => ({
        ...item,
        children: this.buildMenuTree(items, item.id) // 递归处理子菜单
      }))
      // 按Sort字段降序排序
      .sort((a, b) => b.sort - a.sort);
    return children;
  }
  onMenuClick(menu: any) {
    console.log('menu-----',menu);
    
    var tabIndex = this.tabs.findIndex(s => s.id == menu.id);
    if (tabIndex > -1) {
      this.selectedIndex = tabIndex;
      return;
    }
    if (menu.href) {
      let href = this.sanitizer.bypassSecurityTrustResourceUrl(menu.href);
      this.tabs.push({ name: menu.name, id: menu.id, href: href, open: menu.open });
      this.selectedIndex = this.tabs.length - 1;
      // 更新激活菜单
      localStorage.setItem('menu', JSON.stringify(menu));
    }
  }
  closeTab({ index }: { index: number }): void {
    this.tabs.splice(index, 1);
  }
  async logout() {
    await this.securityService.logout();
    this.router.navigate(['passport', 'login']);
    localStorage.removeItem('menu');
  }

  pwdSet() {
    this.modalService.create({
      nzTitle: '修改密码',
      nzOnOk: () => {
        //this.refreshList();
      },
      nzContent: PasswordUpdateComponent,
      nzComponentParams: {  }
    });
  }
}
